import theme from 'App.theme';
import { useIsTierZero } from 'hooks/useSubscriptionTier';
import { useState } from 'react';
import FeatureUnavailableDialog from './FeatureUnavailableDialog';
import { Box } from '@mui/material';
import useScreenSize from 'hooks/useScreenSize';
import useNavigationMinimized from 'hooks/navigationMinimized';

const FeatureUnavailableOverlay = () => {
  const isTierZero = useIsTierZero();
  const [showFeatureUnavailableDialog, setShowFeatureUnavailableDialog] = useState(false);

  const [navigationMinimized] = useNavigationMinimized();
  const screenSize = useScreenSize();
  const isSmall = screenSize.width < theme.breakpoints.values.sm;
  const isMedium = screenSize.width < theme.breakpoints.values.lg;
  const offsetLeft = isSmall && navigationMinimized ? 0 : (isSmall && !navigationMinimized) || isMedium ? 80 : 140;

  return isTierZero ? (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: offsetLeft,
          right: 0,
          bottom: 0,
          zIndex: 10,
          cursor: 'pointer',
          backgroundColor: theme.colors.black,
          opacity: 0.25,
        }}
        onClick={() => setShowFeatureUnavailableDialog(val => !val)}
      />
      <FeatureUnavailableDialog
        open={showFeatureUnavailableDialog}
        onClose={() => setShowFeatureUnavailableDialog(false)}
      />
    </>
  ) : null;
};

export default FeatureUnavailableOverlay;
